import { Grid, Paper, Snackbar } from "@material-ui/core";
import { get } from "lodash-es";
import React, { useEffect, useRef, useState } from "react";
import { Navbar } from "react-bootstrap";
import { LoginAsGuest } from "./login-strategies/LoginAsGuest";
import { LoginWithEmailAndPassword } from "./login-strategies/LoginWithEmailAndPassword";
import { LoginWithWindowsAuthentication } from "./login-strategies/LoginWithWindowsAuthentication";
import { LoginWithAzureAD } from "./login-strategies/azure-ad/LoginWithAzureAD";
import { LoginParams } from "./models/login.models";

export function Login({ authConfig }: LoginParams) {
	const params = useRef(new URL(document.location as any).searchParams);
	const [open, setOpen] = useState(false);
	const [message, setMessage] = useState("");

	const useEmailAndPassword = get(authConfig, "useEmailAndPassword", true);
	const useAzureAD = get(authConfig, "useAzureAD", false);
	const useWindowsAuth = get(authConfig, "useWindowsAuth", false);
	const guestIsEnabled = get(authConfig, "guestIsEnabled", false);

	const handleClose = () => {
		setOpen(false);
		params.current.delete("message");
		const newUrl = window.location.origin + "?" + params.current.toString();
		window.history.replaceState({ path: newUrl }, "", newUrl);
	};

	useEffect(() => {
		if (params.current.has("message")) {
			setMessage(params.current.get("message")!);
			setOpen(true);
		}
	}, [params.toString()]);

	return (
		<React.Fragment>
			<header>
				<Navbar
					variant="dark"
					expand="lg"
					className="mes-primary-color mes-menu-top"
				>
					<Navbar.Brand href="/">MESF</Navbar.Brand>
				</Navbar>
			</header>
			<div className="container-fluid">
				<div className="row">
					<div className="col-10 col-md-6 mx-auto my-5">
						<Paper elevation={2}>
							<div className="card-header text-center">
								<b>LOGIN</b>
							</div>
							<Grid
								container
								justifyContent="space-between"
								alignItems="center"
							>
								{!useAzureAD && !guestIsEnabled && !useWindowsAuth ? (
									<Grid item xs={12}>
										<Paper
											elevation={2}
											style={{ padding: 40, margin: "40px 40px 40px 40px" }}
										>
											{useEmailAndPassword && <LoginWithEmailAndPassword />}
										</Paper>
									</Grid>
								) : (
									<>
										<Grid item md={5} xs={5}>
											<Paper
												elevation={2}
												style={{ padding: 40, margin: "40px -40px 40px 40px" }}
											>
												{useEmailAndPassword && <LoginWithEmailAndPassword />}
											</Paper>
										</Grid>
										<Grid item md={1} xs={1} style={{ maxWidth: "20px" }}>
											<span className="text-muted font-weight-bold">OR</span>
										</Grid>
										<Grid item md={5} xs={5} style={{ marginBottom: "auto" }}>
											<Paper
												elevation={2}
												style={{
													padding: 40,
													margin: "40px 40px 40px -40px",
													minHeight: 248,
													display: "flex",
													flexDirection: "column",
													justifyContent: "space-evenly",
												}}
											>
												<>
													<LoginWithWindowsAuthentication />
													{useAzureAD && (
														<LoginWithAzureAD config={authConfig.AzureConfig} />
													)}
													{guestIsEnabled && <LoginAsGuest />}
												</>
											</Paper>
										</Grid>
									</>
								)}
							</Grid>
						</Paper>
					</div>
				</div>
			</div>
			<Snackbar
				open={open}
				autoHideDuration={6000}
				onClose={handleClose}
				message={message}
			/>
		</React.Fragment>
	);
}
